import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "name", "profession", "contactEmail", "phone", "address", "city", "state", "postalCode", "country", "timeZone", "continueBtn"
  ]

  connect() {
    console.log("BasicInfoController connected")
    this.validateFields()
    // Add input listeners for each target
    if (this.hasNameTarget) this.nameTarget.addEventListener("input", () => this.validateFields())
    if (this.hasProfessionTarget) this.professionTarget.addEventListener("input", () => this.validateFields())
    if (this.hasContactEmailTarget) this.contactEmailTarget.addEventListener("input", () => this.validateFields())
    if (this.hasPhoneTarget) this.phoneTarget.addEventListener("input", () => this.validateFields())
    if (this.hasAddressTarget) this.addressTarget.addEventListener("input", () => this.validateFields())
    if (this.hasCityTarget) this.cityTarget.addEventListener("input", () => this.validateFields())
    if (this.hasStateTarget) this.stateTarget.addEventListener("input", () => this.validateFields())
    if (this.hasPostalCodeTarget) this.postalCodeTarget.addEventListener("input", () => this.validateFields())
    if (this.hasCountryTarget) this.countryTarget.addEventListener("input", () => this.validateFields())
    if (this.hasTimeZoneTarget) this.timeZoneTarget.addEventListener("input", () => this.validateFields())
  }

  validateFields() {
    const requiredFields = [
      this.hasNameTarget ? this.nameTarget.value.trim() : "",
      this.hasProfessionTarget ? this.professionTarget.value.trim() : "",
      this.hasContactEmailTarget ? this.contactEmailTarget.value.trim() : "",
      this.hasPhoneTarget ? this.phoneTarget.value.trim() : "",
      this.hasAddressTarget ? this.addressTarget.value.trim() : "",
      this.hasCityTarget ? this.cityTarget.value.trim() : "",
      this.hasStateTarget ? this.stateTarget.value.trim() : "",
      this.hasPostalCodeTarget ? this.postalCodeTarget.value.trim() : "",
      this.hasCountryTarget ? this.countryTarget.value.trim() : "",
      this.hasTimeZoneTarget ? this.timeZoneTarget.value.trim() : ""
    ]
    const allFilled = requiredFields.every(val => val.length > 0)
    if (this.hasContinueBtnTarget) {
      this.continueBtnTarget.disabled = !allFilled
    }
  }
}
